export default {
  backEndUrl: 'http://be.template.dblandit.com/',
};
